import { useState, useEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';
import GeneralDataSection from './GeneralDataSection';
import ContactDataSection from './ContactDataSection';
import AdditionalDataSection from './AdditionalDataSection';

const LegalEntityDialog = ({
  open,
  onClose,
  editMode,
  selectedLegalEntity,
  onInputChange,
  onSelectChange,
  onSave,
  countries,
  provinces,
  departments,
  districts,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [locationState, setLocationState] = useState({
    district: null,
    department: null,
    province: null,
    country: null,
  });

  useEffect(() => {
    if (!editMode || !selectedLegalEntity.uuid_district) {
      setLocationState({
        district: null,
        department: null,
        province: null,
        country: null,
      });
      return;
    }

    const selectedDistrict = districts.find(
      (dist) => dist.uuid === selectedLegalEntity.uuid_district
    );
    const selectedDepartment = departments.find(
      (dep) => dep.uuid === selectedDistrict?.uuid_department
    );
    const selectedProvince = provinces.find(
      (prov) => prov.uuid === selectedDepartment?.uuid_province
    );
    const selectedCountry = countries.find(
      (country) => country.uuid === selectedProvince?.uuid_country
    );

    setLocationState({
      district: selectedDistrict,
      department: selectedDepartment,
      province: selectedProvince,
      country: selectedCountry,
    });
  }, [selectedLegalEntity, districts, departments, provinces, countries, editMode]);

  const commonProps = {
    selectedLegalEntity,
    onInputChange,
    onSelectChange,
    isMobile,
    editMode,
  };

  return (
    <DialogContainer open={open} onClose={onClose} size={isMobile ? 'small' : 'fullWidth'}>
      <DialogTitle>{editMode ? 'Editar Persona Jurídica' : 'Agregar Persona Jurídica'}</DialogTitle>

      <DialogBody sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 3 }}>
        <Box sx={{ flex: 1 }}>
          <GeneralDataSection {...commonProps} />
        </Box>
        {!isMobile && (
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'divider',
              mx: 2,
            }}
          />
        )}
        <Box sx={{ flex: 1 }}>
          <ContactDataSection
            {...commonProps}
            countries={countries}
            provinces={provinces}
            departments={departments}
            districts={districts}
            locationState={locationState}
          />
        </Box>
        {!isMobile && (
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'divider',
              mx: 2,
            }}
          />
        )}
        <Box sx={{ flex: 1 }}>
          <AdditionalDataSection {...commonProps} />
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onSave} />
    </DialogContainer>
  );
};

export default LegalEntityDialog;
